"use client";

import { useEffect } from "react";

export function PwaRegister() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    // Turbopack dev builds don't reliably rotate chunk filenames on content
    // change the way production builds do — sw.js's cache-first strategy for
    // /_next/static/ then serves stale dev bundles indefinitely. Production-only.
    if (process.env.NODE_ENV !== "production") {
      // Not registering here isn't enough — a browser that visited earlier
      // (before this check existed) still has the old worker installed and
      // will keep serving stale cached bundles forever until it's explicitly
      // removed. Clean it up so dev doesn't need a manual console command.
      navigator.serviceWorker.getRegistrations().then((regs) => {
        for (const reg of regs) reg.unregister();
      });
      if (typeof caches !== "undefined") {
        caches.keys().then((keys) => {
          for (const key of keys) caches.delete(key);
        });
      }
      return;
    }
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Installability/offline support is a nice-to-have — a failed
      // registration (e.g. unsupported browser, dev tooling) shouldn't
      // affect the rest of the app.
    });
  }, []);

  return null;
}
